import { render } from "./DeleteIcon.vue?vue&type=template&id=275f6f36&scoped=true"
import script from "./DeleteIcon.vue?vue&type=script&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&lang=js"

import "./DeleteIcon.vue?vue&type=style&index=0&id=275f6f36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275f6f36"]])

export default __exports__